import { render } from "./ResultBlockForm.vue?vue&type=template&id=76ac86a0&scoped=true&ts=true"
import script from "./ResultBlockForm.vue?vue&type=script&lang=ts"
export * from "./ResultBlockForm.vue?vue&type=script&lang=ts"

import "./ResultBlockForm.vue?vue&type=style&index=0&id=76ac86a0&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ac86a0"]])

export default __exports__